// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"J8VY_","text":"_3af9I","small":"kZ4Hu"};